'use client';

import { FC } from 'react';
import { Check } from 'lucide-react';
import styles from './CompareCardCheckbox.module.scss';
interface Props {
  picked: boolean;
}

/**
 * Round checkbox in a card's top-left corner while compare mode is on. Purely
 * visual: the whole card is the click target (see ListingCard `compare`).
 */
const CompareCardCheckbox: FC<Props> = ({
  picked
}) => <span className={`${styles.checkbox} ${picked ? styles.picked : ''}`} aria-hidden="true" data-sentry-component="CompareCardCheckbox" data-sentry-source-file="CompareCardCheckbox.tsx">
        {picked && <Check size={14} strokeWidth={3} />}
    </span>;
export default CompareCardCheckbox;